/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import { VinculoDto } from '../../modules/auth'
import { deleteFuncionario } from '../../modules/apps/funcionarios/funcionarios-list/core/_requests'
import { getUserByCPF } from '../../modules/auth/core/_requests'
import {
  CargoType,
  IconPaths,
  ID,
  showAlert,
  showError,
  toAbsoluteUrl,
} from '../../../_metronic/helpers'
import { Label } from '../Label/Label'
import { ButtonIcon } from '../Button/ButtonIcon'

type Props = {
  vinculos: VinculoDto[] | undefined
  cpf: string | undefined
}

export const VinculoEmpresaCard: React.FC<Props> = ({ vinculos, cpf }) => {
  const [vinculosForm, setVinculosForm] = useState(vinculos)

  const removerVinculo = async (idVinculo: ID) => {
    const result = await Swal.fire({
      title: 'Confirma a exclusão do funcionário?',
      text: 'Essa ação não pode ser desfeita!',
      icon: 'info',

      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-secondary',
      },
      buttonsStyling: false,
    })
    if (result.isConfirmed) {
      try {
        await deleteFuncionario(idVinculo)

        if (cpf !== undefined) {
          const { data } = await getUserByCPF(cpf)
          setVinculosForm(data.vinculos)
        }

        showAlert({ title: 'Sucesso!', text: 'Vinculo removido com sucesso.', icon: 'success' })
      } catch (error) {
        showError(error)
      }
    }
  }

  useEffect(() => {
    setVinculosForm(vinculos)
  }, [vinculos])

  const vinculosSemPaciente = vinculosForm?.filter((vinculo) => !vinculo.paciente)

  return (
    <div className='row mb-3' key={1}>
      {vinculosSemPaciente && vinculosSemPaciente.length > 0 ? (
        vinculosSemPaciente.map((vinculo) => (
          <div className='d-flex col-md-6 mb-5' key={vinculo.id}>
            <div className='d-flex align-items-center col-md-2'>
              <div className='symbol symbol-50px me-3'>
                <img src={toAbsoluteUrl('/media/empresa/predio.png')} alt='Instituição vinculada' />
              </div>
            </div>
            <div className='d-flex flex-column justify-content-center col-md-9'>
              <Label>{vinculo.empresa?.nomeFantasia}</Label>

              <span className='text-muted d-block fw-semibold'>
                {vinculo.cargo === CargoType.Colaborador
                  ? 'Colaborador'
                  : vinculo.cargo === CargoType.Medico
                  ? 'Profissional de Saúde'
                  : 'Responsável'}
              </span>
            </div>
            <div className='d-flex flex-start col-md-1'>
              <ButtonIcon
                className='p-0'
                icon={IconPaths.Delete}
                onClick={() => removerVinculo(vinculo.id)}
                color='red'
              />
            </div>
          </div>
        ))
      ) : (
        <div>
          <span className='text-muted d-block fw-semibold'>Usuário sem vínculo</span>
        </div>
      )}
    </div>
  )
}
